import React, { useState } from 'react'
import ImageUploader from 'react-images-upload'
import Axios from 'axios'

import './App.css'

const UploadComponent = props => (
  <ImageUploader
    key='image-uploader'
    withIcon
    singleImage
    withPreview
    label='Maximum size file: 5MB'
    buttonText='Зураг сонгох'
    onChange={props.onImage}
    imgExtension={['.jpg', '.png', '.jpeg']}
    maxFileSize={5242880}
  />
)
const SingleImage = (props) => {
  return (
    <div style={{ display: 'inline', width: '80px', float: 'left', padding: '4px' }}>
      <img src={props.img} style={{ maxWidth: '100%' }} />
      <input type='hidden' name='images[]' value={props.img} />
    </div>
  )
}
const UploadedImages = (props) => {
  return (
    <div id='uploaded-images' style={{ width: '100%', clear: 'both' }}>
      {
        props.images.map((image, i) => {
          return <SingleImage img={image} key={i} />
        })
      }
    </div>
  )
}

const App = () => {
  const [progress, setProgress] = useState('getUpload')
  // const [url, setImageURL] = useState(undefined)
  const [count, setCount] = useState(0)
  const [images, setImages] = useState([])
  const [errorMessage, setErrorMessage] = useState('')
  const url = 'https://fmyzdoq1dl.execute-api.eu-west-1.amazonaws.com/dev/image-upload'

  const onImage = async (failedImages, successImages) => {
    if (!url) {
      console.log('missing Url')
      setErrorMessage('missing a url to upload to')
      setProgress('uploadError')
      return
    }

    setProgress('uploading')

    try {
      console.log('successImages', successImages)
      const parts = successImages[0].split(';')
      const mime = parts[0].split(':')[1]
      const name = parts[1].split('=')[1]
      const data = parts[2]
      const res = await Axios.post(url, { mime, name, image: data, dir: window.location.hostname })
      // document.getElementById('upload-form').innerHTML = res.data.imageURL
      setImages([...images, res.data.imageURL])
      setCount(count + 1)
      setProgress('uploaded')
    } catch (error) {
      console.log('error in upload', error)
      setErrorMessage(error.message)
      setProgress('uploadError')
    }
  }

  const content = () => {
    switch (progress) {
      case 'getUpload':
        return <UploadComponent onImage={onImage} url={url} />
      case 'uploading':
        return <span>Илгээж байна...</span>
      case 'uploaded':
        return <UploadComponent onImage={onImage} url={url} />
      case 'uploadError':
        return (
          <>
            <div>Error message = {errorMessage}</div>
            <UploadComponent onImage={onImage} url={url} />
          </>
        )
    }
  }

  return (
    <div id='upload-form'>
      <UploadedImages images={images} />
      {content()}
    </div>
  )
}

export default App
